<ng-container *ngIf="!!daysScheduled">
    <div class="planningItem popup">
        <div class="planningItem-header">
            <h3 class="planningItem-header-title"[i18nKey]="'schedule.players.title'"></h3>
            <span class="bullet left"></span>
            <span class="bullet right"></span>

            <i class="fas fa-times closePopup" (click)="close()"></i>
        </div>
        <div class="planningItem-content">
            <ng-container *ngIf="daysScheduled.length > 0 && !!daysScheduled">
                <div class="taskItem" *ngFor="let day of daysScheduled ; index as i">
                    <div class="taskItem-header">
                        <i class="fas fa-tasks"></i> {{day | date:'fullDate':'':'fr-FR' }}
                    </div>
                    <div class="taskItem-tasks" *ngFor="let event of eventsScheduled[i]">
                        <p class="task">
                            <kiwi-period [period]="event.periodId"></kiwi-period>
                            : <span>
                        <span [i18nKey]="'schedule.players.from'"></span>
                        {{event.startDate | date:'shortTime':'':'fr-FR'}}
                        <span [i18nKey]="'schedule.players.to'"></span>
                        {{event.endDate | date:'shortTime':'':'fr-FR'}}</span></p>
                    </div>
                </div>
            </ng-container>

            <div class="planningEmpty" *ngIf="daysScheduled.length === 0">
                <div class="planningEmpty-img"></div>
                <span class="planningEmpty-title"[i18nKey]="'planning.unavailable.title'"></span>
                <span class="planningEmpty-text"[i18nKey]="'planning.unavailable.text'"></span>
            </div>
        </div>
    </div>

    <div class="overlay" (click)="close()"></div>
</ng-container>
